import moment from 'moment';
import range from 'lodash/range';

const MIN_YEAR = 1981;

export function getYears() {
  const currentYear = range(moment().format('YYYY'), MIN_YEAR - 1);
  return currentYear;
}
